<template>
  <div>
    <cpu-info
      class="px-1"
      :show-title="false"
      :host="host"
    />
    <cpu-chart class="mt-2" />
  </div>
</template>
<script>
import CpuInfo from './info/CpuInfo.vue'
import CpuChart from './charts/CpuChart.vue'

export default {
  name: 'HostDetailsCPU',
  components: { CpuInfo, CpuChart },
  props: {
    host: {
      type: Object,
      required: true,
    },
  },
}
</script>
